import styled from '@emotion/styled';
import React from 'react';
import { mapConcessionToIcons } from './utils/mapConcession';
export const DOUBLE_YOUR_ODDS = 'DoubleYourOdds';
export const StyledConcessionIconContainer = styled.div `
  margin-right: ${({ theme }) => theme.space[2]};
  position: relative;
  z-index: 2;

  svg {
    display: block;
  }
`;
export const EpicValueIcon = ({ concession }) => {
    var _a;
    const Icon = (_a = mapConcessionToIcons[concession]) === null || _a === void 0 ? void 0 : _a.icon;
    if (!Icon)
        return null;
    return (React.createElement(StyledConcessionIconContainer, null,
        React.createElement(Icon, { width: concession === DOUBLE_YOUR_ODDS ? 22 : 12, height: 12 })));
};
